export const apiKey = "0e9e647ea010d8b3410709d41b745d87";
export const apiUrl = "https://api.themoviedb.org/3/";